import styled from '@emotion/styled'

export const mobile = '@media (max-width: 768px)'
const font = '"Segoe UI", Arial'

const flexRow = `
  display: flex;
`

const flexCol = `
  ${flexRow}
  flex-direction: column;
`

const containerBase = `
  width: 1180px;
  margin: 0 auto;
`

export const MainWrapper = styled.div`
  ${flexCol}
  width: 100%;
`

export const Container = styled.section`
  ${containerBase}
  padding: 80px 10px 0;
  position: relative;

  ${mobile} {
    width: 100%;
    padding: 40px 20px 0;
  }
`

export const Wrapper = styled.div``

export const Content = styled.div`
  margin-bottom: 30px;
`

export const Title = styled.h2`
  font: 400 35px ${font};
  color: #78be20;
  display: flex;
  margin-bottom: 20px;

  span {
    font-weight: 800;
    margin-right: 10px;
  }

  ${mobile} {
    font-size: 28px;
    flex-wrap: wrap;
  }
`

export const Row = styled.div`
  ${flexRow}
  gap: 15px;

  ${mobile} {
    flex-direction: column;
  }
`

export const MainInfo = styled.div`
  width: 493px;
  border: 2px solid #eeeef0;
  padding: 30px 25px;
  border-radius: 20px;

  h3 {
    color: #78be20;
    font: bold 22px ${font};
    margin-bottom: 10px;
  }

  h4 {
    font: bold 22px ${font};
  }

  ${mobile} {
    width: 100%;
    padding: 25px 20px;
  }
`

export const OtherInfos = styled.div`
  ${flexRow}
  flex-wrap: wrap;
  gap: 15px;

  ${mobile} {
    flex-direction: column;
  }
`

export const BoxText = styled.div<{
  $width?: number
  $highlight?: boolean
  $column?: boolean
}>`
  ${flexRow}
  gap: 10px;
  flex-direction: ${({ $column }) => ($column ? 'column' : 'row')};
  background-color: ${({ $highlight }) =>
    $highlight ? '#eef7e4' : 'transparent'};
  border: 2px solid #eeeef0;
  padding: 25px;
  border-radius: 20px;
  width: ${({ $width }) => ($width ? `${$width}px` : '360px')};

  h4 {
    font: bold 17px ${font};
    line-height: 22px;
  }

  p {
    font: 400 17px ${font};
    line-height: 26px;
  }

  strong {
    font-weight: bold;
  }

  ${mobile} {
    width: 100%;
    padding: 20px;
    flex-direction: column;
  }
`

export const Footer = styled.div`
  background: #78be20;

  p {
    padding: 10px 0 20px;
    font: 400 18px ${font};
    line-height: 30px;
  }
`

export const Center = styled.section`
  ${containerBase}
  padding: 20px 10px;
  ${flexCol}

  ${mobile} {
    width: 100%;
    padding: 20px;
  }
`
